module.exports = __webpack_public_path__ + "static/media/features_img_two.8b0d25e9.png";